import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_error/403")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="flex flex-col items-center justify-center min-h-[80vh] p-8 text-center">
			<h1 className="text-4xl font-bold mb-4">🚫 403 - Access Denied</h1>

			<div className="mb-8">
				<img
					src="https://http.dog/403.jpg"
					alt="403 dog"
					className="rounded-lg shadow-lg max-w-md mx-auto dark:brightness-90"
				/>
			</div>

			<div className="max-w-lg mx-auto space-y-4">
				<p className="text-xl mb-4">
					Whoops! Looks like you don't have permission to access this page.
				</p>

				<div className="text-gray-600 dark:text-gray-400">
					<p className="text-left">Here are a few things you can try:</p>
					<ul className="list-disc list-inside mt-2 text-left">
						<li>Double check that you're logged in</li>
						<li>Contact your team admin if you need access</li>
						<li>Go back to the previous page</li>
						<li>Head to the home page</li>
					</ul>
				</div>

				<div className="flex gap-4 justify-center mt-8">
					<Button
						type="button"
						onClick={() => window.history.back()}
						className="bg-gray-200 dark:bg-gray-700 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
					>
						← Go Back
					</Button>
					<Button
						asChild
						className="bg-blue-500 text-white rounded hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 transition-colors"
					>
						<Link to="/">Home Page</Link>
					</Button>
				</div>
			</div>
		</div>
	);
}
